import styled from 'styled-components';

export const HorizontalBar = styled.div`
margin-top: 20px;
margin-bottom: 20px;
height:7px;
background-color: var(--primaryRgb);
width:100%;
`;
